import DurationIcon from 'assets/icons/form-icons/DurationIcon';
import strings from 'strings/strings.json';
import styled from 'styled-components';
import { theme, sizes } from 'theme';
import { BodySmall, FlexSmAlignCenter } from './Elements';

type DurationLabelProps = {
    durationInMins: number;
    hideTitle?: boolean;
    noBackgroundColour?: boolean;
};

export default function DurationLabel({
    durationInMins,
    hideTitle,
    noBackgroundColour = false,
}: DurationLabelProps): JSX.Element {
    return (
        <DurationLabelContainer $noBackgroundColour={noBackgroundColour}>
            {!hideTitle && <BodySmall>{strings.OAScheduleCourseForm.durationLabel}</BodySmall>}
            <FlexSmAlignCenter>
                <DurationIcon />
                <BodySmall $nowrap>{`${durationInMins} ${durationInMins === 1 ? 'min' : 'mins'}`}</BodySmall>
            </FlexSmAlignCenter>
        </DurationLabelContainer>
    );
}

const DurationLabelContainer = styled.div<{ $noBackgroundColour?: boolean }>`
    display: flex;
    flex-direction: column;
    background: ${({ $noBackgroundColour }) => ($noBackgroundColour ? 'none' : theme.cardThirdBackgroundColour)};
    padding: ${sizes.spacingXs} ${sizes.spacingSm};
    border-radius: ${sizes.borderRadiusMd};
    width: min-content;
`;
